module.exports = __webpack_public_path__ + "img/2@3x.7d1274c7.png";